<template>
  <section class="section bg-light2">
    <div class="container container-small">
      <AccentHeader :header="header" :underline="true" :uppercase="false"/>
      <SwipeHandler @swipeLeft="swipeLeft" @swipeRight="swipeRight">
        <div class="events-wrapper">
          <SliderControllers @showPrev="showPrev" @showNext="showNext" :displayPrev="true" :displayNext="true" :hideMobile="false" :small="true"/>
          <div class="slide-wrapper">
            <div class="slide"
              v-for="(item, index) in items"
              :key="'item' + index"
              :class="{
                prev: index == (activeItem - 1 + items.length) % items.length,
                active: index == activeItem,
                next: index == (activeItem + 1) % items.length
              }">
              <EventPreview :item="item" />
              <div class="slide-btn">
                <router-link v-if="item.id"
                  :to="{ name: 'wydarzenia', params: { id: item.id }}"
                  class="btn btn-simple">
                  {{ buttonData.readMore }}
                </router-link>
              </div>
            </div>
          </div>
          <nav>
            <ul class="nav">
              <EventsNav v-for="(item, index) in items" :key="index" :item="item" :class="{active: index == activeItem}" @setActive="setActive(index)"/>
            </ul>
          </nav>
        </div>
      </SwipeHandler>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import EventPreview from '@/components/EventPreview.vue'
import EventsNav from '@/components/EventsNav.vue'
import AccentHeader from '@/components/AccentHeader.vue'
import SliderControllers from '@/components/SliderControllers.vue'
import SwipeHandler from '@/components/SwipeHandler.vue'

export default {
  name: 'eventSection',
  components: {
    EventPreview,
    EventsNav,
    AccentHeader,
    SliderControllers,
    SwipeHandler
  },
  props: ['items', 'header'],
  data: function () {
    return {
      activeItem: 0,
      loop: false,
      loopTimeout: null
    }
  },
  methods: {
    stopLoop () {
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    startLoop () {
      window.clearTimeout(this.loopTimeout)
      this.loop = true
      this.loopTimeout = window.setTimeout(() => {
        this.loopNext()
      }, 1000)
    },
    swipeLeft () {
      this.showNext()
    },
    swipeRight () {
      this.showPrev()
    },
    showNext () {
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    setActive (index) {
      this.loop = false
      window.clearTimeout(this.loopTimeout)
      let difference = Math.abs(this.activeItem - index)
      if (difference) {
        if (difference !== 1) {
          this.activeItem += this.activeItem - index > 0 ? -1 : 1
          setTimeout(() => {
            this.setActive(index)
          }, 500)
        } else {
          this.activeItem = index
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'buttonData'
    ])
  }
}
</script>

<style scoped lang="scss">
  .section {
    .container {
      padding: 58px 0;
      @include mobile {
        padding: 45px 0 0;
      }
    }
  }
  .events-wrapper {
    margin-top: 53px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: flex-start;
    position: relative;
    @include tablet {
      position: static;
    }
    @include mobile {
      margin-top: 20px;
    }
  }
  .slide-wrapper {
    width: 60vw;
    // height: 350px;
    // flex-direction: row;
    display: flex;
    // flex-wrap: nowrap;
    overflow: hidden;
    position: relative;
    // align-items: flex-start;
    // justify-content: flex-start;
    // align-content: flex-start;
    // justify-content: space-around;
    flex: 1;
    // position: relative;
    // @include tablet {
    //   height: 320px;
    // }
    // @include mobile {
    //   height: 620px;
    //   height: calc(100vw + 130px);
    // }
    // @include mobile-small {
    //   height: 620px;
    //   height: calc(100vw + 400px);
    // }
    // .font-size-l & {
    //   height: 450px;
    //   @include mobile {
    //     height: 750px;
    //   }
    // }
  }
  nav {
    width: 28%;
    @include tablet {
      display: none;
    }
  }
  .nav {
    list-style: none;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .slide {
    display: none;
    // flex: none;
    width: 100%;
    max-width: 800px;
    // position: absolute;
    // top: 0;
    // left: 0;
    transition: $transitionSlider;
    text-align: left;

    &.active,
    &.prev,
    &.next {
      display: flex;
      flex-flow: column nowrap;
    }

    &.prev,
    &.next {
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
    }
    &.prev {
      transform: translateX(-100vw);
    }
    &.next {
      transform: translateX(100vw);
    }
    &.active {
      opacity: 1;
      position: relative;
      transform: translateX(0);
    }

    &-btn {
      margin: $gap-md 0 $gap-xl;
      position: relative;
      text-align: right;

      @include screen ('sm') {
        left: 44%;
        margin: 0 0 0 ($gap-md * 2);
        text-align: left;
        width: 50%;
      }
      @include screen ('md') {
        margin-top: $gap-md;
      }
      @include screen ('xl') {
        left: 36%;
        margin-top: ($gap-md * 3);
      }

    } // END .slide-btn;

  } // END .slide;
  .controllers {
    position: absolute;
    z-index: 3;
    bottom: -10px;
    // transform: translateY(100%);
    left: -10px;
    width: 90px;
    height: 50px;
    @include tablet {
      top: 50px;
      bottom: auto;
      left: auto;
      right: 0;
    }
    @include mobile {
      top: 54px;
    }
  }
</style>
